import {
  LIST_ASSETS_SUCCESS,
  LIST_ASSETS_FAILED,
  CREATE_ASSETS_SUCCESS,
  CREATE_ASSETS_FAILED,
  CLEAR_ASSETS_ERROR,
  SET_ASSETS_ISOPEN,
  SET_ASSET_EDIT_DATA,
  SET_ALERT_ASSET,
} from '../actions/types';
const initialState = {
  loading: true,
  isError: false,
  isErrorType: null,
  errMessage: null,
  data: [],
  isOpen: false,
  editData: {},
  isAlert: false,
  alertType: null,
  alertMessage: null,
};

function companyReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LIST_ASSETS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload.data,
      };
    case LIST_ASSETS_FAILED:
      return {
        ...state,
        loading: false,
        data: [],
      };
    case CREATE_ASSETS_SUCCESS:
      return {
        ...state,
        isError: false,
        isErrorType: payload.type,
        errMessage: payload.message,
      };
    case CREATE_ASSETS_FAILED:
      return {
        ...state,
        isError: true,
        isErrorType: payload.type,
        errMessage: payload.message,
      };
    case CLEAR_ASSETS_ERROR:
      return {
        ...state,
        isError: false,
        isErrorType: null,
        errMessage: null,
        isOpen: false,
      };
    case SET_ASSETS_ISOPEN:
      return {
        ...state,
        isOpen: payload,
      };
    case SET_ASSET_EDIT_DATA:
      return {
        ...state,
        editData: payload,
      };
    case SET_ALERT_ASSET:
      return {
        ...state,
        isAlert: payload.status,
        alertMessage: payload.message,
        alertType: payload.type,
      };
    default:
      return state;
  }
}

export default companyReducer;
